// extracted by mini-css-extract-plugin
export default {"content":"InitialStep_content__bwW32","content__documents":"InitialStep_content__documents__VYcFb","content__submission":"InitialStep_content__submission__IWN3I"};